import { useState } from "react";
import { formatSouthAsianNumber } from "../../utils/utils";
import RankOne from "../../assets/images/rank-1.svg";
import { GetDashboardTopTradersResponseType } from "../../types/trader.type";

type Props = {
  data: GetDashboardTopTradersResponseType|undefined;
  isLoading: boolean;
};

const TopTraders = ({ data, isLoading }: Props) => {
  const [topTradersToShow, setTopTradersToShow] = useState(3);
  const [showMoreButton, setShowMoreButton] = useState(true);

  const toggleShowTopDealers = () => {
    if (showMoreButton) {
      setTopTradersToShow(data?.data.length || 0);
      setShowMoreButton(false);
    } else {
      setTopTradersToShow(3);
      setShowMoreButton(true);
    }
  };

  if (isLoading) {
    return (
      <div className="mt-3">
        <div className="h-[87px] bg-slate-100 w-full my-2"></div>
        <div className="h-[87px] bg-slate-100 w-full my-2"></div>
        <div className="h-[87px] bg-slate-100 w-full my-2"></div>
      </div>
    );
  }

  return (
    <div className="mt-3 flex flex-col">
      {data?.data?.slice(0, topTradersToShow)?.map((dealer, index) => (
        <div
          className={`flex justify-between py-4 ${
            index !== data.data.slice(0, topTradersToShow).length - 1 &&
            "border-solid border-b border-t-0 border-l-0 border-r-0 dark:border-[#3D4A5C] border-[#D7DFE9]"
          }`}
          key={index}
        >
          <div className="flex gap-2 items-center">
            <div>
              <img
                src={dealer.profile.logoImage || ""}
                className="w-12 h-12 rounded-full"
                alt=""
              />
            </div>
            <div>
              <div className="dark:text-header text-others-table-header flex items-center gap-2">
                <span>{dealer.profile.merchantName || ""}</span>

                {index === 0 && (
                  <div>
                    <img src={RankOne} alt="Rank One" />
                  </div>
                )}
              </div>
              <div className="text-body">{dealer.traderId || ""}</div>
            </div>
          </div>
          <div className="flex gap-2 items-center">
            <div>
              <div className="text-[12px] dark:text-body text-others-table-header">
                Value
              </div>
              <div className="dark:text-header text-body">
                ৳{formatSouthAsianNumber(dealer.supplierPaymentAmount)}
              </div>
            </div>
            {/* <div>
              <div className="text-[12px] dark:text-body text-others-table-header">
                Trx
              </div>
              <div className="dark:text-header text-body"></div>
            </div> */}
          </div>
        </div>
      ))}

      <div
        className="flex justify-center font-semibold text-primary cursor-pointer"
        onClick={toggleShowTopDealers}
      >
        {showMoreButton ? "Show more" : "Show less"}
      </div>
    </div>
  );
};

export default TopTraders;
